import { StyleProp, ViewStyle } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
} from "react";
import LottieViewWeb, { LottieRefCurrentProps } from "lottie-react";

type Props = {
  source: string;
  style?: StyleProp<ViewStyle>;
  autoPlay?: boolean;
  loop?: boolean;
  speed?: number;
  direction?: 1 | -1;
};

type LottieViewRef = {
  reset: () => void;
  play: () => void;
  pause: () => void;
};

const LottieView = (
  { source, style, autoPlay, loop, speed, direction }: Props,
  ref: React.Ref<LottieViewRef>
) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);
  useImperativeHandle(ref, () => ({
    reset: () => {},
    play: () => lottieRef.current?.play(),
    pause: () => lottieRef.current?.pause(),
  }));
  useEffect(() => {
    if (direction) {
      lottieRef.current?.setDirection(direction);
    }
  }, [direction]);
  return (
    <LottieViewWeb
      lottieRef={lottieRef}
      animationData={source}
      style={style as any}
      autoPlay={autoPlay}
      loop={loop}
    />
  );
};

export default forwardRef(LottieView);

const styles = StyleSheet.create({});
